
// See details: https://kazupon.github.io/vue-i18n/en/number.html
export default {

	'en': {
		currency: {
			style: 'currency',
			currency: 'USD'
		}
	}

};



// WEBPACK FOOTER //
// ./src/locales/number-formats.js